module.exports = __webpack_public_path__ + "img/activecodingtest.ada3c360.svg";